import React, { useEffect, useRef, useState } from 'react';
import wishSound from './images/wish.mp3';
import p1_pic1 from './images/p1_pic1.webp';
import p1_pic2 from './images/p1_pic2.webp';
import p1_pic3 from './images/p1_pic3.webp';
import p1_pic4 from './images/p1_pic4.webp';
import p1_pic5 from './images/p1_pic5.webp';
// Tambah p2
import p2_pic1 from './images/p2_pic1.webp';
import p2_pic2 from './images/p2_pic2.webp';
import p2_pic3 from './images/p2_pic3.webp';
import p2_pic4 from './images/p2_pic4.webp';
import p2_pic5 from './images/p2_pic5.webp';
import p2_pic6 from './images/p2_pic6.webp';
import p2_pic7 from './images/p2_pic7.webp';
import p3_pic1 from './images/p3_pic1.webp';
import p3_pic2 from './images/p3_pic2.webp';
import p3_pic3 from './images/p3_pic3.webp';
import p3_pic4 from './images/p3_pic4.webp';
import p3_pic5 from './images/p3_pic5.PNG';
import p3_pic6 from './images/p3_pic6.webp';
import p4_pic1 from './images/p4_pic1.webp';
import p4_pic2 from './images/p4_pic2.webp';
import p5_pic1 from './images/p5_pic1.webp';
import p5_pic2 from './images/p5_pic2.webp';
import p5_pic3 from './images/p5_pic3.webp';
import p5_pic4 from './images/p5_pic4.webp';
import p6_pic1 from './images/p6_pic1.webp';
import p6_pic2 from './images/p6_pic2.webp';
import p6_pic3 from './images/p6_pic3.webp';
import p6_pic4 from './images/p6_pic4.webp';
import p6_pic5 from './images/p6_pic5.webp';
import p7_pic1 from './images/p7_pic1.webp';
import p7_pic2 from './images/p7_pic2.webp';
import p7_pic3 from './images/p7_pic3.webp';
import p7_pic4 from './images/p7_pic4.webp';
import p7_pic5 from './images/p7_pic5.webp';
import p7_pic6 from './images/p7_pic6.webp';

export default function WishPage() {
  const videoRef = useRef();
  const [showText, setShowText] = useState(false);
  const [showedText, setShowedText] = useState(false);
  const [videoDone, setVideoDone] = useState(false); // triggers fade logic
  const [hideAll, setHideAll] = useState(false); // triggers full unmount of video/overlay
  // each image appears at step: 1 (pic2), 2 (pic4), 3(pic5), 4(pic3)
  const [imgStep, setImgStep] = useState(0);
  // Separate state for fade out video+teks only
  const [fadeOutSection0, setFadeOutSection0] = useState(false);
  const section2Ref = useRef(null);
  const [imgStep2, setImgStep2] = useState(0);
  const [section2Visible, setSection2Visible] = useState(false); // SECTION 2 only after anim 1 finish
  const [imgStep3, setImgStep3] = useState(0);
  const [section3Visible, setSection3Visible] = useState(false);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);
  const [section4Visible, setSection4Visible] = useState(false);
  const [showWishText, setShowWishText] = useState(false);
  const [isToggled4, setIsToggled4] = useState(false); // toggle untuk section 4
  const [bgFade, setBgFade] = useState(1); // 1: p4_pic2 full, 0: p4_pic1 full
  const section5Ref = useRef(null);
  const [section5Visible, setSection5Visible] = useState(false);
  const [imgStep5, setImgStep5] = useState(0);
  const section6Ref = useRef(null);
  const [section6Visible, setSection6Visible] = useState(false);
  const [imgStep6, setImgStep6] = useState(0);
  const [isToggled6, setIsToggled6] = useState(false); // toggle untuk section 6
  const [bgFade6, setBgFade6] = useState(0); // 0: p6_pic1 full, 1: p6_pic4 full
  const [fadeHidePic6, setFadeHidePic6] = useState(1); // 1: show pic2/pic3; 0: hide
  const [fadeShowPic6_5, setFadeShowPic6_5] = useState(0); // 0: hide, 1: show p6_pic5
  const section7Ref = useRef(null);
  const [section7Visible, setSection7Visible] = useState(false);
  const [imgStep7, setImgStep7] = useState(0);
  const [isToggled7, setIsToggled7] = useState(false); // toggle untuk section 7
  const [fadeP7_2To6, setFadeP7_2To6] = useState(0); // 0: p7_pic2 full, 1: p7_pic6 full
  const wishAudioRef = useRef(null);
  const hasStartedAudio = useRef(false);

  // Initialize and play wish sound
  useEffect(() => {
    // Initialize audio
    wishAudioRef.current = new Audio(wishSound);
    wishAudioRef.current.loop = true;
    wishAudioRef.current.volume = 1;

    // Try to play immediately
    const tryPlay = async () => {
      if (wishAudioRef.current) {
        try {
          await wishAudioRef.current.play();
          hasStartedAudio.current = true;
        } catch (e) {
          console.log('Audio play failed, will retry on user interaction:', e);
        }
      }
    };
    tryPlay();

    // Try to play on first user interaction (fallback for autoplay policy)
    const handleFirstInteraction = () => {
      if (!hasStartedAudio.current && wishAudioRef.current) {
        wishAudioRef.current.play().catch(() => { });
        hasStartedAudio.current = true;
      }
    };

    const events = ['click', 'keydown', 'touchstart', 'mousedown', 'scroll'];
    events.forEach(event => {
      document.addEventListener(event, handleFirstInteraction, { once: true });
    });

    return () => {
      // Cleanup
      if (wishAudioRef.current) {
        wishAudioRef.current.pause();
        wishAudioRef.current.currentTime = 0;
        wishAudioRef.current = null;
      }
      events.forEach(event => {
        document.removeEventListener(event, handleFirstInteraction);
      });
    };
  }, []);

  // Detect section2 masuk viewport
  useEffect(() => {
    function onScroll() {
      if (!section2Ref.current) return;
      const rect = section2Ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.76 && imgStep2 === 0) {
        let n = 0;
        const interval = setInterval(() => {
          n++; setImgStep2(k => Math.max(k, n));
          if (n >= 7) clearInterval(interval);
        }, 1000);
        // Only run once!
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [imgStep2]);

  // Time control to fade section0 then show section1
  useEffect(() => {
    if (!videoDone) return;
    // trigger fadeout section0
    setFadeOutSection0(true);
    // 1.2s fade duration, then fully unmount section0 and show section1
    const showSection1 = setTimeout(() => setHideAll(true), 1200);
    // Step sequence images: +1s each after section1 show
    let timers = [];
    for (let i = 1; i <= 4; ++i) {
      timers.push(setTimeout(() => setImgStep(v => v + 1), 1200 + 1000 * i));
    }
    return () => {
      clearTimeout(showSection1);
      timers.forEach(t => clearTimeout(t));
    };
  }, [videoDone]);

  // Video timing (trigger videoDone)
  useEffect(() => {
    if (!videoRef.current) return;
    const vid = videoRef.current;
    function handleTimeUpdate() {
      if (!vid.duration || showedText) return;
      if ((vid.duration - vid.currentTime) <= 1) {
        setShowText(true);
        setShowedText(true);
      }
    }
    function handleEnded() {
      setTimeout(() => setVideoDone(true), 200); // allow a slight buffer for fade
    }
    vid.addEventListener('timeupdate', handleTimeUpdate);
    vid.addEventListener('ended', handleEnded);
    return () => {
      vid.removeEventListener('timeupdate', handleTimeUpdate);
      vid.removeEventListener('ended', handleEnded);
    };
  }, [showedText]);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().then(() => {
        // Video play is user interaction, so we can play audio now
        if (!hasStartedAudio.current && wishAudioRef.current) {
          wishAudioRef.current.play().catch(() => { });
          hasStartedAudio.current = true;
        }
      }).catch(() => { });
    }
  }, []);
  // Caveat font inject
  useEffect(() => {
    if (!document.getElementById('caveat-font')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.id = 'caveat-font';
      link.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap';
      document.head.appendChild(link);
    }
  }, []);
  // Font inject Homemade Apple
  useEffect(() => {
    if (!document.getElementById('homemade-font')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.id = 'homemade-font';
      link.href = 'https://fonts.googleapis.com/css2?family=Homemade+Apple&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  // Hapus auto-scroll logic: no useEffect for wheel/touchmove!

  // Setelah gambar animasi terakhir tampil, baru show SECTION 2
  useEffect(() => {
    if (imgStep >= 4 && !section2Visible) {
      setSection2Visible(true);
    }
    // Optional: jika ingin reset saat imgStep turun (tidak di use-case ini)
  }, [imgStep, section2Visible]);

  // Logic tampilkan Section 3 setelah animasi Section 2 selesai
  useEffect(() => {
    if (imgStep2 >= 7 && !section3Visible) {
      setSection3Visible(true);
      // let n = 0; // Hapus interval otomatis section3 lama
      // const interval = setInterval(() => { // Hapus interval otomatis section3 lama
      //   n++; // Hapus interval otomatis section3 lama
      //   setImgStep3(k => Math.max(k, n)); // Hapus interval otomatis section3 lama
      //   if (n >= 6) clearInterval(interval); // Hapus interval otomatis section3 lama
      // }, 1000); // Hapus interval otomatis section3 lama
      // return () => clearInterval(interval); // Hapus interval otomatis section3 lama
    }
  }, [imgStep2, section3Visible]);

  // Logic: animasi gambar Section 3 jalan saat scroll masuk section 3
  useEffect(() => {
    if (!section3Visible) return;
    function onScrollSection3() {
      if (!section3Ref.current || imgStep3 > 0) return;
      const rect = section3Ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.76) {
        let n = 0;
        const interval = setInterval(() => {
          n++;
          setImgStep3(k => Math.max(k, n));
          if (n >= 6) clearInterval(interval);
        }, 1000);
        window.removeEventListener('scroll', onScrollSection3);
      }
    }
    window.addEventListener('scroll', onScrollSection3, { passive: true });
    return () => window.removeEventListener('scroll', onScrollSection3);
  }, [section3Visible, imgStep3]);

  // Section 4: show saat discroll masuk, trigger interval lihat wish
  useEffect(() => {
    if (!section4Visible || showWishText) return;
    let timeout;
    function handleScroll4() {
      if (!section4Ref.current) return;
      const rect = section4Ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.7) {
        timeout = setTimeout(() => setShowWishText(true), 1000);
        window.removeEventListener('scroll', handleScroll4);
      }
    }
    window.addEventListener('scroll', handleScroll4, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll4);
      if (timeout) clearTimeout(timeout);
    };
  }, [section4Visible, showWishText]);
  // Logic tampilkan Section 4 jika Section 3 sudah selesai stepnya
  useEffect(() => {
    if (imgStep3 >= 6 && !section4Visible) {
      setSection4Visible(true);
    }
  }, [imgStep3, section4Visible]);
  // Section 5: show saat discroll masuk, trigger anim step antar gambar
  useEffect(() => {
    if (!section5Visible) return;
    function onScroll5() {
      if (!section5Ref.current || imgStep5 > 0) return;
      const rect = section5Ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.81) {
        let n = 0;
        const interval = setInterval(() => {
          n++;
          setImgStep5(k => Math.max(k, n));
          if (n >= 4) clearInterval(interval);
        }, 1000);
        window.removeEventListener('scroll', onScroll5);
      }
    }
    window.addEventListener('scroll', onScroll5, { passive: true });
    return () => window.removeEventListener('scroll', onScroll5);
  }, [section5Visible, imgStep5]);
  // Tampilkan section 5 jika scroll ke bawah setelah section 4
  useEffect(() => {
    if (showWishText && !section5Visible) {
      setSection5Visible(true);
    }
  }, [showWishText, section5Visible]);
  // Fade logic: saat toggle, bg fade ke p4_pic1 (fade out), lalu kembali p4_pic2 saat toggle lagi (fade in)
  useEffect(() => {
    let fade;
    if (isToggled4) {
      // Fade out: dari p4_pic2 ke p4_pic1
      fade = setInterval(() => setBgFade(v => {
        if (v <= 0) {
          clearInterval(fade);
          return 0;
        }
        return Math.max(0, v - 0.07);
      }), 16);
    } else {
      // Fade in: dari p4_pic1 ke p4_pic2
      fade = setInterval(() => setBgFade(v => {
        if (v >= 1) {
          clearInterval(fade);
          return 1;
        }
        return Math.min(1, v + 0.06);
      }), 16);
    }
    return () => clearInterval(fade);
  }, [isToggled4]);

  // Section 6: trigger visible setelah section 5 selesai dan scroll masuk
  useEffect(() => {
    if (!section6Visible) return;
    function onScroll6() {
      if (!section6Ref.current || imgStep6 > 0) return;
      const rect = section6Ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.81) {
        let n = 0;
        const interval = setInterval(() => {
          n++;
          setImgStep6(k => Math.max(k, n));
          if (n >= 2) clearInterval(interval);
        }, 1000);
        window.removeEventListener('scroll', onScroll6);
      }
    }
    window.addEventListener('scroll', onScroll6, { passive: true });
    return () => window.removeEventListener('scroll', onScroll6);
  }, [section6Visible, imgStep6]);
  // Section 6 diaktifkan saat section 5 sudah selesai stepnya
  useEffect(() => {
    if (imgStep5 >= 4 && !section6Visible) setSection6Visible(true);
  }, [imgStep5, section6Visible]);
  // Fade logic untuk bg p6_pic4, pic2/pic3 fade out, dan pic5 fade in
  useEffect(() => {
    let fadeBg, fadePics, fadePic5Delay, fadePic5;
    if (isToggled6) {
      // Fade out: pic2/pic3 memudar, bg ke p6_pic4, lalu pic5 muncul
      fadeBg = setInterval(() => setBgFade6(v => {
        if (v >= 1) {
          clearInterval(fadeBg);
          return 1;
        }
        return Math.min(1, v + 0.09);
      }), 14);
      fadePics = setInterval(() => setFadeHidePic6(v => {
        if (v <= 0) {
          clearInterval(fadePics);
          return 0;
        }
        return Math.max(0, v - 0.09);
      }), 14);
      fadePic5Delay = setTimeout(() => {
        fadePic5 = setInterval(() => setFadeShowPic6_5(v => {
          if (v >= 1) {
            clearInterval(fadePic5);
            return 1;
          }
          return Math.min(1, v + 0.12);
        }), 18);
      }, 1000);
    } else {
      // Fade in: kembali ke state awal
      fadeBg = setInterval(() => setBgFade6(v => {
        if (v <= 0) {
          clearInterval(fadeBg);
          return 0;
        }
        return Math.max(0, v - 0.12);
      }), 12);
      fadePics = setInterval(() => setFadeHidePic6(v => {
        if (v >= 1) {
          clearInterval(fadePics);
          return 1;
        }
        return Math.min(1, v + 0.10);
      }), 14);
      fadePic5 = setInterval(() => setFadeShowPic6_5(v => {
        if (v <= 0) {
          clearInterval(fadePic5);
          return 0;
        }
        return Math.max(0, v - 0.12);
      }), 13);
    }
    return () => {
      clearInterval(fadeBg);
      clearInterval(fadePics);
      clearTimeout(fadePic5Delay);
      clearInterval(fadePic5);
    }
  }, [isToggled6]);

  // ---- SECTION 7 ACTIVATION ----
  useEffect(() => {
    if (!section7Visible) return;
    function onScroll7() {
      if (!section7Ref.current || imgStep7 > 0) return;
      const rect = section7Ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.88) {
        let n = 0;
        const interval = setInterval(() => {
          n++;
          setImgStep7(k => Math.max(k, n));
          if (n >= 4) clearInterval(interval);
        }, 1000);
        window.removeEventListener('scroll', onScroll7);
      }
    }
    window.addEventListener('scroll', onScroll7, { passive: true });
    return () => window.removeEventListener('scroll', onScroll7);
  }, [section7Visible, imgStep7]);
  useEffect(() => {
    if (imgStep6 >= 2 && !section7Visible) setSection7Visible(true);
  }, [imgStep6, section7Visible]);
  // ---- FADE LOGIC P7 PIC2<->PIC6 ----
  useEffect(() => {
    let fadeInt;
    if (isToggled7) {
      // Fade out: dari p7_pic2 ke p7_pic6
      fadeInt = setInterval(() => setFadeP7_2To6(v => {
        if (v >= 1) {
          clearInterval(fadeInt);
          return 1;
        }
        return Math.min(1, v + 0.09);
      }), 15);
    } else {
      // Fade in: kembali dari p7_pic6 ke p7_pic2
      fadeInt = setInterval(() => setFadeP7_2To6(v => {
        if (v <= 0) {
          clearInterval(fadeInt);
          return 0;
        }
        return Math.max(0, v - 0.09);
      }), 15);
    }
    return () => clearInterval(fadeInt);
  }, [isToggled7]);

  // refs tambahan
  const allSectionsRefs = [section2Ref, section3Ref, section4Ref, section5Ref, section6Ref, section7Ref];
  // --- update showNextArrow state (hanya true jika anim selanjutnya benar2 belum mulai) ---
  const showArrowSection1 = (imgStep >= 4 && imgStep2 === 0);
  const showArrowSection2 = (imgStep2 >= 7 && imgStep3 === 0);
  const showArrowSection3 = (imgStep3 >= 6 && imgStep5 === 0);
  const showArrowSection4 = (showWishText && imgStep5 === 0);
  const showArrowSection5 = (imgStep5 >= 4 && imgStep6 === 0);
  const showArrowSection6 = (imgStep6 >= 2 && imgStep7 === 0);

  // RENDER
  return (
    <div style={{
      width: '100vw',
      minHeight: '200vh',
      position: 'relative',
      zIndex: 9000,
      background: 'white',
      overflowX: 'hidden',
    }}>
      {/* SECTION 0: Video + Teks + Fade */}
      {!hideAll && (
        <section style={{
          width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden',
          background: '#070719',
          opacity: fadeOutSection0 ? 0 : 1,
          transition: 'opacity 1.1s cubic-bezier(.42,1.21,.68,1.04)',
          zIndex: 10,
          pointerEvents: fadeOutSection0 ? 'none' : 'auto',
        }}>
          {/* VIDEO + OVERLAY */}
          <video
            ref={videoRef}
            src={require('./images/bday.mp4')}
            autoPlay
            muted
            playsInline
            style={{ width: '100vw', height: '100vh', objectFit: 'cover', display: 'block', zIndex: 1 }}
            loop={false}
            controls={false}
          ></video>
          {/* black transparent overlay */}
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.13)', zIndex: 3 }} />
          {showText && (
            <div style={{
              position: 'fixed',
              top: '32%',
              left: '50%',
              transform: 'translate(-50%,-50%)',
              zIndex: 12,
              pointerEvents: 'none',
              width: 'max-content',
              height: 'auto',
              display: 'block',
              margin: 0,
            }}>
              <span style={{
                color: '#fff',
                fontWeight: 900,
                fontFamily: `'Homemade Apple', cursive`,
                fontSize: window.innerWidth < 470 ? '2.6rem' : '3.5rem',
                letterSpacing: '2.8px',
                textAlign: 'center',
                animation: 'popHB2 1.6s cubic-bezier(.18,1.47,.77,.99)',
                userSelect: 'none',
                lineHeight: 1.2,
                background: 'none',
                display: 'block',
                whiteSpace: 'pre',
                opacity: 1,
                margin: 0,
              }}>
                <span className="shine-hb">to my <br /> novacaine</span>
              </span>
              <style>{`
                @keyframes popHB2 {
                  0%{opacity:0;transform:scale(0.68) translateY(15px);letter-spacing:8px;}
                  49%{opacity:1;transform:scale(1.21) translateY(-2px);letter-spacing:2.2px;}
                  79%{transform:scale(1) translateY(0px);} 100%{opacity:0.97; letter-spacing:1.7px;}
                }
                @keyframes shine {
                  0%{filter:brightness(1.08);}
                  50%{filter:brightness(1.22);}
                  100%{filter:brightness(1.08);}
                }
                .shine-hb { display:inline-block; animation: shine 1.6s; }
              `}</style>
            </div>
          )}
        </section>
      )}
      {/* SECTION 1: Bagian P1 dgn bg image, height=100vh, position relative */}
      {hideAll && (
        <section style={{
          width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden',
          zIndex: 1,
          background: `url(${p1_pic1}) center/cover no-repeat`,
        }}>
          <AnimateImg src={p1_pic2} show={imgStep >= 1} direction="left" zIndex={20} />
          <AnimateImg src={p1_pic4} show={imgStep >= 2} direction="top" zIndex={21} />
          <AnimateImg src={p1_pic5} show={imgStep >= 3} direction="right" zIndex={22} />
          <AnimateImg src={p1_pic3} show={imgStep >= 4} direction="left2" zIndex={23} />
        </section>
      )}
      {/* SECTION 2: manual scroll! */}
      {section2Visible && (
        <section ref={section2Ref} style={{ width: '100vw', height: '100vh', background: '#191514', position: 'relative', zIndex: 30, margin: 0, padding: 0 }}>
          <AnimateImg2 src={p2_pic1} show={imgStep2 >= 1} type="p2_pic1" />
          <AnimateImg2 src={p2_pic2} show={imgStep2 >= 2} type="p2_pic2" />
          <AnimateImg2 src={p2_pic3} show={imgStep2 >= 3} type="p2_pic3" />
          <AnimateImg2 src={p2_pic4} show={imgStep2 >= 4} type="p2_pic4" />
          <AnimateImg2 src={p2_pic5} show={imgStep2 >= 5} type="p2_pic5" />
          <AnimateImg2 src={p2_pic6} show={imgStep2 >= 6} type="p2_pic6" />
          <AnimateImg2 src={p2_pic7} show={imgStep2 >= 7} type="p2_pic7" />
        </section>
      )}
      {section3Visible && (
        <section ref={section3Ref} style={{ width: '100vw', height: '100vh', background: `url(${p3_pic1}) center/cover no-repeat`, position: 'relative', zIndex: 40, margin: 0, padding: 0, overflow: 'hidden' }}>
          <AnimateImg3 src={p3_pic2} show={imgStep3 >= 1} type="p3_pic2" />
          <AnimateImg3 src={p3_pic3} show={imgStep3 >= 2} type="p3_pic3" />
          <AnimateImg3 src={p3_pic4} show={imgStep3 >= 3} type="p3_pic4" />
          <AnimateImg3 src={p3_pic5} show={imgStep3 >= 4} type="p3_pic5" />
          <AnimateImg3 src={p3_pic6} show={imgStep3 >= 5} type="p3_pic6" />
        </section>
      )}
      {section4Visible && (
        <section
          ref={section4Ref}
          style={{ width: '100vw', height: '100vh', position: 'relative', zIndex: 50, overflow: 'hidden', margin: 0, padding: 0, background: '#CCCCCC', cursor: 'pointer' }}
          onClick={() => setIsToggled4(prev => !prev)}
        >
          {/* Background switching/fade p4_pic2 <-> p4_pic1 */}
          <img
            src={p4_pic1}
            alt="wish-bg1"
            style={{
              position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh', objectFit: 'cover', zIndex: 1, opacity: 1 - bgFade, transition: 'opacity 0.45s'
            }}
            draggable={false}
          />
          <img
            src={p4_pic2}
            alt="wish-bg2"
            style={{
              position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh', objectFit: 'cover', zIndex: 2, opacity: bgFade, transition: 'opacity 0.49s'
            }}
            draggable={false}
          />
          {showWishText && (
            <div
              style={{
                position: 'absolute', left: '50%', top: '15%', zIndex: 5, transform: 'translate(-50%,-50%)', fontFamily: "'Homemade Apple', cursive", fontSize: '1rem', fontWeight: 400, color: '#000', letterSpacing: '2.3px', textAlign: 'center', userSelect: 'none', opacity: 0.97, padding: '20px 33px', width: '210px', borderRadius: '22px', animation: 'pop-homemade 1s cubic-bezier(.24,1.53,.71,1.06)'
              }}>
              tap to see the wish
              <style>{`
                @keyframes pop-homemade {
                  0%{opacity:0;transform:scale(0.75) translate(-40%,-72%);}
                  62%{opacity:1;transform:scale(1.18) translate(-50%,-54%);}
                  100%{opacity:0.97;transform:scale(1) translate(-50%,-50%);}
                }
              `}</style>
            </div>
          )}
        </section>
      )}
      {section5Visible && (
        <section ref={section5Ref}
          style={{ width: '100vw', height: '100vh', position: 'relative', zIndex: 60, overflow: 'hidden', margin: 0, padding: 0, background: '#eee' }}>
          <img
            src={p5_pic1}
            alt="p5-bg"
            style={{ position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh', objectFit: 'cover', zIndex: 1 }} />
          <AnimateImg5 src={p5_pic2} show={imgStep5 >= 1} type="p5_pic2" />
          <AnimateImg5 src={p5_pic3} show={imgStep5 >= 2} type="p5_pic3" />
          <AnimateImg5 src={p5_pic4} show={imgStep5 >= 3} type="p5_pic4" />
        </section>
      )}
      {section6Visible && (
        <section ref={section6Ref}
          style={{ width: '100vw', height: '100vh', position: 'relative', zIndex: 70, overflow: 'hidden', margin: 0, padding: 0, background: '#f9f9f9', cursor: 'pointer' }}
          onClick={() => setIsToggled6(prev => !prev)}>
          <img
            src={p6_pic1}
            alt="p6-base"
            style={{ position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh', objectFit: 'cover', zIndex: 1, opacity: 1 - bgFade6, transition: 'opacity 0.49s' }} />
          <img
            src={p6_pic4}
            alt="p6-bg4"
            style={{ position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh', objectFit: 'cover', zIndex: 2, opacity: bgFade6, transition: 'opacity 0.49s' }} />
          <AnimateImg6 src={p6_pic2} show={imgStep6 >= 1} fade={fadeHidePic6} type="p6_pic2" />
          <AnimateImg6 src={p6_pic3} show={imgStep6 >= 2} fade={fadeHidePic6} type="p6_pic3" />
          <AnimateImg6 src={p6_pic5} show={fadeShowPic6_5 > 0.01} fade={fadeShowPic6_5} type="p6_pic5" />
        </section>
      )}
      {section7Visible && (
        <section ref={section7Ref}
          style={{ width: '100vw', height: '100vh', position: 'relative', zIndex: 80, overflow: 'hidden', margin: 0, padding: 0, background: '#fff', cursor: 'pointer' }}
          onClick={() => setIsToggled7(prev => !prev)}
        >
          <img
            src={p7_pic1}
            alt="p7-bg"
            style={{
              position: 'absolute', left: 0, top: 0,
              width: '100vw', height: '100vh',
              minWidth: '100vw', minHeight: '100vh',
              objectFit: 'fill',
              zIndex: 1
            }}
          />
          {/* Anim images 1 by 1 */}
          <AnimateImg7 src={p7_pic2} type="p7_pic2" show={imgStep7 >= 1 && fadeP7_2To6 < 0.98} fade={1 - fadeP7_2To6} />
          <AnimateImg7 src={p7_pic6} type="p7_pic6" show={imgStep7 >= 1 && fadeP7_2To6 > 0.01} fade={fadeP7_2To6} />
          <AnimateImg7 src={p7_pic3} type="p7_pic3" show={imgStep7 >= 2} fade={1} />
          <AnimateImg7 src={p7_pic4} type="p7_pic4" show={imgStep7 >= 3} fade={1} />
          <AnimateImg7 src={p7_pic5} type="p7_pic5" show={imgStep7 >= 4} fade={1} />
        </section>
      )}
      {/* Next arrows for each section (tidak muncul jika animasi belum full selesai). */}
      <NextSectionArrow
        show={showArrowSection1}
        onClick={() => { allSectionsRefs[0].current && allSectionsRefs[0].current.scrollIntoView({ behavior: 'smooth' }); }}
      />
      <NextSectionArrow
        show={showArrowSection2}
        onClick={() => { allSectionsRefs[1].current && allSectionsRefs[1].current.scrollIntoView({ behavior: 'smooth' }); }}
      />
      <NextSectionArrow
        show={showArrowSection3}
        onClick={() => { allSectionsRefs[2].current && allSectionsRefs[2].current.scrollIntoView({ behavior: 'smooth' }); }}
      />
      <NextSectionArrow
        show={showArrowSection4}
        onClick={() => { allSectionsRefs[3].current && allSectionsRefs[3].current.scrollIntoView({ behavior: 'smooth' }); }}
      />
      <NextSectionArrow
        show={showArrowSection5}
        onClick={() => { allSectionsRefs[4].current && allSectionsRefs[4].current.scrollIntoView({ behavior: 'smooth' }); }}
      />
      <NextSectionArrow
        show={showArrowSection6}
        onClick={() => { allSectionsRefs[5].current && allSectionsRefs[5].current.scrollIntoView({ behavior: 'smooth' }); }}
      />
    </div>
  );
}

// Helper animation per image
function AnimateImg({ src, show, direction, zIndex }) {
  // Direction-based positioning (each pic custom style)
  let styleByImg = {};
  // p1_pic2: dari kiri
  if (src && src.includes('p1_pic2')) {
    styleByImg = {
      position: 'fixed',
      top: show ? '35%' : '52%',
      left: show ? '-8%' : '-46vw',
      width: '600px',
      height: 'auto',
      // maxWidth: '154vw',
      maxHeight: '70vh',
      zIndex: 23,
      pointerEvents: 'none',
      opacity: show ? 1 : 0,
      transform: show ? 'translate(-50%,-50%) scale(1)' : 'translateY(-55%)',
      transition: 'all 0.98s cubic-bezier(.4,1.36,.6,.97) 0ms',
    };
  }
  // p1_pic4: dari atas
  else if (src && src.includes('p1_pic4')) {
    styleByImg = {
      position: 'fixed',
      top: show ? '20%' : '-32vh',
      left: show ? '70%' : '51%',
      width: '200px',
      // width: 'min(47vw, 265px)',
      height: 'auto',
      // maxWidth: '69vw',
      maxHeight: '54vh',
      zIndex: zIndex || 21,
      pointerEvents: 'none',
      opacity: show ? 1 : 0,
      transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.87)',
      transition: 'all 0.99s cubic-bezier(.4,1.36,.6,.97) 0ms',
      zoom: '140%'
    };
  }
  // p1_pic5: dari kanan
  else if (src && src.includes('p1_pic5')) {
    styleByImg = {
      position: 'fixed',
      top: show ? '62%' : '51%',
      left: show ? '65%' : '107vw',
      width: '200px',
      // width: 'min(53vw, 240px)',
      height: 'auto',
      // maxWidth: '73vw',
      maxHeight: '53vh',
      zIndex: zIndex || 22,
      pointerEvents: 'none',
      opacity: show ? 1 : 0,
      transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.92)',
      transition: 'all 0.99s cubic-bezier(.4,1.36,.6,.97) 0ms',
      zoom: '140%'
    };
  }
  // p1_pic3: dari kiri 2 (lebih ke bawah)
  else if (src && src.includes('p1_pic3')) {
    styleByImg = {
      position: 'fixed',
      top: show ? '86%' : '67%',
      left: show ? '20%' : '-43vw',
      // width: 'min(44vw, 190px)',
      width: '190px',
      height: 'auto',
      // maxWidth: '59vw',
      maxHeight: '47vh',
      zIndex: 20,
      pointerEvents: 'none',
      opacity: show ? 1 : 0,
      transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.85)',
      transition: 'all 1.05s cubic-bezier(.39,1.35,.69,.97) 0ms',
      zoom: '180%'
    };
  } else {
    // fallback for direction left/top/right/left2 (if direction passed by prop, not src str)
    styleByImg = {
      position: 'fixed',
      zIndex: zIndex || 20,
      width: 'min(60vw,400px)',
      maxWidth: '92vw',
      maxHeight: '74vh',
      pointerEvents: 'none',
      top: show ? '50%' : '54%',
      left: show ? '50%' : '-44vw',
      transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.8)',
      opacity: show ? 1 : 0,
      transition: 'all 0.99s cubic-bezier(.4,1.36,.6,.97)',
    }
  }
  return <img src={src} alt="pic" style={styleByImg} />;
}

function AnimateImg2({ src, show, type }) {
  let st = { position: 'absolute', opacity: show ? 1 : 0, transition: 'all 0.95s cubic-bezier(.41,1.14,.61,1.01)' };
  if (type === "p2_pic1") Object.assign(st, {
    top: show ? '75%' : '110%', left: '50%', transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(-50%,0%) scale(0.91)',
    // width: 'min(53vw,330px)', 
    width: '230px', zIndex: 24, zoom: '170%'
  });
  if (type === "p2_pic2") Object.assign(st, { top: '90%', left: show ? '50%' : '107vw', transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.81)', width: 'min(44vw,310px)', zIndex: 25, zoom: '80%' });
  if (type === "p2_pic3") Object.assign(st, { top: '83%', left: show ? '25%' : '-44vw', transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.81)', width: 'min(34vw,170px)', zIndex: 26, zoom: '100%' });
  if (type === "p2_pic4") Object.assign(st, {
    top: '48.3%', left: show ? '53%' : '-60vw', transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.79)',
    //  width: 'min(32vw,180px)', 
    width: '120px', zIndex: 20, rotate: '-5deg', zoom: '260%'});
  if (type === "p2_pic5") Object.assign(st, { top: '20%', left: show ? '30%' : '-50vw', transform: show ? 'translate(-50%,-50%) scale(1)' : 'scale(0.81)', width: 'min(35vw,160px)', zIndex: 28, zoom: '180%', display: 'none' });
  if (type === "p2_pic6") Object.assign(st, { top: show ? '15%' : '-32vh', left: '80%', transform: show ? 'translate(-50%,-50%) scale(1)' : 'translateY(-30%) scale(0.80)', width: 'min(44vw,195px)', zIndex: 29 });
  if (type === "p2_pic7") Object.assign(st, { top: show ? '23%' : '-30%', left: '35%', transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(-50%,0%) scale(0.95)', width: 'min(60vw,340px)', zIndex: 30 });
  return <img src={src} style={st} alt='' draggable={false} />;
}

function AnimateImg3({ src, show, type }) {
  // Unik style per gambar (top/left/size/anim beda)
  let st = { position: 'absolute', opacity: show ? 1 : 0, transition: 'all 1.02s cubic-bezier(.44,1.18,.61,1.01)', zIndex: 41 };
  if (type === 'p3_pic2') Object.assign(st, {
    top: show ? '35%' : '-28vh',
    left: '30%',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(-50%,-3%) scale(0.98)',
    width: 'min(43vw, 310px)'
  });
  if (type === 'p3_pic3') Object.assign(st, {
    top: '66%',
    left: show ? '75%' : '110vw',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translateY(0%) scale(0.95)',
    width: 'min(41vw, 280px)'
  });
  if (type === 'p3_pic4') Object.assign(st, {
    top: '35%',
    left: show ? '75%' : '110vw',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translateX(0%) scale(0.95)',
    width: 'min(41vw, 190px)'
  });
  if (type === 'p3_pic5') Object.assign(st, {
    top: '55%',
    left: show ? '30%' : '-40vw',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translateX(0%) scale(0.9)',
    width: 'min(41vw, 190px)',
    // zoom:'55%'
  });
  if (type === 'p3_pic6') Object.assign(st, {
    top: '67%',
    left: show ? '22%' : '-44vw',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translateX(-12%) scale(0.93)',
    width: '23%'
  });
  return <img src={src} style={st} alt='' draggable={false} />;
}

function AnimateImg5({ src, show, type }) {
  // Style animasi berbeda tiap gambar
  let st = { position: 'absolute', opacity: show ? 1 : 0, transition: 'all 1s cubic-bezier(.47,1.19,.54,.98)', zIndex: 5 };
  if (type === 'p5_pic2') Object.assign(st, {
    top: show ? '20%' : '-33%',
    left: '50%',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(-50%,0%) scale(0.98)',
    // width: 'min(50vw, 360px)',
    width:'190px',
    zoom: '190%'
  });
  if (type === 'p5_pic3') Object.assign(st, {
    top: '43%',
    left: show ? '52%' : '120vw',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translateY(0%) scale(0.97)',
    // width: 'min(44vw, 310px)',
    width:'180px',
    zoom: '200%'
  });
  if (type === 'p5_pic4') Object.assign(st, {
    top: show ? '73%' : '118vh',
    left: '50%',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(-50%,0%) scale(0.98)',
    // width: 'min(37vw, 210px)',
    width: '140px',
    zoom: '180%'
  });
  return <img src={src} style={st} alt='' draggable={false} />;
}

function AnimateImg6({ src, show, fade, type }) {
  // Tiap gambar punya animasi dan fade sendiri
  let st = { position: 'absolute', opacity: show ? fade : 0, transition: 'all 1s cubic-bezier(.53,1.18,.57,1.01), opacity 0.5s', zIndex: 5 };
  if (type === 'p6_pic2') Object.assign(st, {
    top: show ? '28%' : '-25%',
    left: '50%',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(-50%,10%) scale(0.95)',
    // width: 'min(53vw, 350px)',
    width:'200px',
    zoom: '180%'
  });
  if (type === 'p6_pic3') Object.assign(st, {
    top: '75%',
    left: show ? '50%' : '120vw',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(0%,0%) scale(0.96)',
    // width: 'min(41vw, 270px)',
    width:'180px',
    zoom: '220%'
  });
  if (type === 'p6_pic5') Object.assign(st, {
    top: '50%',
    left: '50%',
    transform: show ? 'translate(-50%,-50%) scale(1)' : 'translate(-50%,-50%) scale(1)',
    // width: 'min(52vw, 320px)',
    width:'175px',
    filter: show ? `opacity(${fade})` : 'opacity(0)',
    zoom: '180%'
  });
  return <img src={src} style={st} alt='' draggable={false} />;
}

function AnimateImg7({ src, show, fade, type }) {
  let st = { position: 'absolute', opacity: show ? fade : 0, zIndex: 5 };
  if (type === 'p7_pic2') Object.assign(st, {
    top: '50%',
    left: '30%',
    transform: 'translate(-50%,-50%)',
    // width: 'min(45vw,308px)',
    width:'220px',
    transition: 'opacity 0.45s'
  });
  if (type === 'p7_pic6') Object.assign(st, {
    top: '50%',
    left: '30%',
    transform: 'translate(-50%,-50%)',
    // width: 'min(45vw,308px)',
    width:'220px',
    transition: 'opacity 0.45s'
  });
  if (type === 'p7_pic3') Object.assign(st, {
    top: show ? '23%' : '56%',
    left: show ? '72%' : '108vw',
    transform: show ? 'translate(-50%,-50%)' : 'translateX(0%)',
    width: 'min(46vw,265px)',
    transition: 'all 1s cubic-bezier(.56,1.12,.63,1.06), opacity 0.45s'
  });
  if (type === 'p7_pic4') Object.assign(st, {
    top: show ? '29%' : '50%',
    left: show ? '75%' : '120vw',
    transform: show ? 'translate(-50%,-50%)' : 'translateX(0%)',
    width: 'min(35vw,235px)',
    transition: 'all 1s cubic-bezier(.56,1.12,.63,1.06), opacity 0.45s'
  });
  if (type === 'p7_pic5') Object.assign(st, {
    top: show ? '78%' : '120vh',
    left: '23.5%',
    transform: 'translate(-50%,-50%)',
    // width: 'min(40vw,210px)',
    width:'170px',
    transition: 'all 1s cubic-bezier(.56,1.12,.63,1.06), opacity 0.45s'
  });
  return <img src={src} style={st} alt='' draggable={false} />;
}

// --- NextSectionArrow btn ---
function NextSectionArrow({ onClick, show }) {
  const [arrowCount, setArrowCount] = React.useState(1);
  React.useEffect(() => {
    if (!show) return;
    let i = 0;
    const loop = setInterval(() => {
      setArrowCount(((v) => (v % 3) + 1));
      i++;
    }, 340);
    return () => clearInterval(loop);
  }, [show]);
  return show ? (
    <button
      onClick={onClick}
      style={{
        position: 'fixed',
        right: 32, bottom: '2.5em',
        zIndex: 9999,
        background: 'rgba(24, 24, 24, 0.44)',
        color: 'white',
        border: 'none', borderRadius: '50%',
        width: 64, height: 64,
        boxShadow: '0 2px 12px #0003',
        cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
        fontSize: 30,
        opacity: 0.92,
        transition: 'opacity 0.22s',
        gap: '2px', // space antar arrow
      }}
      title="Scroll to next section"
    >
      {/* Animate arrow-down, bertambah jumlanya ke bawah */}
      {[...Array(arrowCount)].map((_, idx) => (
        <svg key={idx} width="33" height="33" viewBox="0 0 24 24" style={{ marginTop: idx === 0 ? 0 : 3 }}>
          <path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
        </svg>
      ))}
    </button>
  ) : null;
}
